import { Box, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TextQuestion(props) {

    const {i18n, t} = useTranslation()

    const index = props.surveyUserData.findIndex((el) => el.questionId === props.questionId)
    const [answer, setAnswer] = useState(index !== -1 ? props.surveyUserData[index].answer : "")

    const handleChange = (e) => {
        setAnswer(e.target.value);
        props.updateSurveyData(props.questionId, e.target.value)
    }


    return(
        <Box sx={{width: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <Typography sx={{fontWeight: 500}}>{props.question[i18n.language]}</Typography>
            <TextField sx={{mt: 2, mb: 2}} onChange={handleChange} value={answer} multiline minRows={3}
                inputProps={{ maxLength: 500 }} placeholder={t("freeTextPlaceholder")}
            />
        </Box>
    )
}